class SrcSetItem {
    path: string;
    size: string;
    constructor (path: string, size: string) {
        this.path = path;
        this.size = size;
    }

    getFullUrl (img: string) {
        const src = img.replace('/dynamic/default/', this.path);
        return `${src} ${this.size}`;
    }
}

const sizes: SrcSetItem[] = [];
sizes.push(new SrcSetItem('/dynamic/480x360c/', '480w'));
sizes.push(new SrcSetItem('/dynamic/240x180c/', '240w'));
sizes.push(new SrcSetItem('/dynamic/320x240c/', '320w'));
sizes.push(new SrcSetItem('/dynamic/640x480c/', '640w'));
sizes.push(new SrcSetItem('/dynamic/480x360c/', '480w'));
sizes.push(new SrcSetItem('/dynamic/960x720c/', '960w'));

export default class SrcSet {
    mainImage: string;
    srcSet: string[];
    constructor (mainImage: string) {
        this.mainImage = mainImage;
        this.srcSet = sizes.map((item) => item.getFullUrl(this.mainImage));
    }
}
